module.exports = __webpack_public_path__ + "img/tomo.406bc53c.svg";